import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { Features } from 'generated/featureDefinitions'
import { useFeatures } from 'modules/core/hooks/useFeatures'

/**
 * Stub page for the ticketing category workflow builder.
 *
 * The real implementation (workflow graph builder, handlers, GraphQL wiring)
 * lands in a follow-up PR. This stub exists so the navigation entry and the
 * `:categoryId/workflow` route are valid in `main` without exposing any
 * unfinished UI to users. Access is gated behind
 * `dev_ai_ticketing_workflows_co_creation`; when the flag is off the page
 * renders nothing.
 */
export const CategoryWorkflowBuilderPage = () => {
  const { has_dev_ai_ticketing_workflows_co_creation, loadingFeatures } = useFeatures([
    Features.dev_ai_ticketing_workflows_co_creation,
  ])

  if (loadingFeatures) {
    return (
      <ResponsivePage.Body variant="fullscreen" height="full" loading error={undefined}>
        {null}
      </ResponsivePage.Body>
    )
  }

  if (!has_dev_ai_ticketing_workflows_co_creation) {
    return null
  }

  return (
    <ResponsivePage.Body variant="fullscreen" showHeader={false}>
      {null}
    </ResponsivePage.Body>
  )
}
